import React from 'react'
import ReactApexChart from 'react-apexcharts';
import pl from "apexcharts/dist/locales/pl.json";

const DonutChartManagement = (props) => {
  const valueConvert = (val) => {
    if (typeof val === typeof 1) return (Number(val).toFixed(2)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
    return val
  }
  const { dataChart, opkSelect } = props
  const dataNames = [
    "Koszty bezpośrednie",
    "Koszty pośrednie działalności medycznej",
    "Koszty pośrednie działalności niemedycznej",
    "Koszty procedur medycznych",
    "Koszty zarządu"
  ]
  const colorPalette = ['#6a76bc', '#8b91c7', '#aaadd2', '#c9c9dd', '#e7e7e7']//["#26c9d7", '#ee8181', '#2681b4', '#26c293', '#ff8250', '#99d766']
  const retData = () => {
    let data = {
      series: dataNames.map(item => { return Number(dataChart[item]) }),
      options: {
      },
    };
    data.options = {
      colors: colorPalette,
      xaxis: { categories: dataNames },
      chart: {
        height: 450,
        type: 'donut',
        toolbar: {
          show: true, 
          tools: {download:{show: true}}
        }
      },
      legend: {
        position: 'bottom',
        fontFamily: "Montserrat, Helvetica Neue",
        fontSize: '12px',
        color: '#263238',
        formatter: function (val) {
          return val
        },
        markers: { radius: 2 },
        // showForNullSeries: false,
        // showForZeroSeries: false,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            minAngleToShowLabel: 1
          }, donut: { labels: { show: false } }
        }
      },
      dataLabels: {
        formatter: function (val, opt) {
          return val ? val.toFixed(2).replace('.', ',') + '%' : ""
        },
        style: {
          fontSize: '12px',
          colors: ["white"],
          fontFamily: "Montserrat, Helvetica Neue",
          fontWeight: 400
        }
      },
      labels: dataNames,
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex }) {
          let column = dataNames[seriesIndex]
          let tooltip = '<div class="arrow-box chart-tooltip">'
          tooltip += '<div style="padding: 3px; font-weight: bold ">' + column + '</div>'
          tooltip += '<div>'
          tooltip += valueConvert(dataChart[column]) + ' zł<br>'
          tooltip += '</div></div>'
          return tooltip
        }
      },
    };
    data.options.chart['locales'] = [pl]
    data.options.chart['defaultLocale'] = "pl"

    return data
  }
  const [chartData, setChartData] = React.useState({ series: [], options: { chart: { height: 500, type: 'donut' } } })
  React.useEffect(() => {
    setChartData(retData())
  }, [dataChart])

  return (<>
    <ReactApexChart
      type={chartData.options.chart.type}
      series={chartData.series}
      options={chartData.options}
      height={chartData.options.chart.height} />
  </>
  )
}
export default DonutChartManagement
